export class FillTypeModel {
cmbFillType: string;
setValue(res){
if(res){
if(res['cmbFillType']){this.cmbFillType = res['cmbFillType'];}
}
}
}